import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { uniqBy } from 'lodash';
import { useSelector } from 'react-redux';
import { BiBed } from 'react-icons/bi';
import RateOption from '../../RateOption';
import RateOptionPriceDisclaimerTooltip from '../../../RateOptionPriceDisclaimerTooltip';
import { SearchStatus } from '../../../../../constants';

const CabinRate = ({
  cabin,
  tripId,
  onModalClose,
  isConfirmation,
  selectedRoomIndex,
  doShowPrice,
  travelOption,
  tripRoomSearchInput,
}) => {
  const { updateBrochurePriceStatus, isViewingBrochure } = useSelector((state) => state.brochure);
  const { isViewingCompare } = useSelector((state) => state.compare);

  const {
    cabinCategoryCode,
    cabinCategoryImage,
    cabinCategoryName,
    resultno,
    cabinCategoryDescription,
    lowestRate,
    lowestTotalAmount,
    rateOptions,
    sessionKey,
  } = cabin;

  const getSortedRateOptions = () => uniqBy(rateOptions, 'rateOptionCode')
    .sort((a, b) => a.price - b.price);

  return (
    <div className="grid gap-5 mx-0 md:mx-5 md:mb-5 p-2 md:p-5 rounded-lg bg-body-0">
      <div className="grid grid-cols-7 gap-5 pb-5 border-b-2 border-light">
        <div className="pt-2 align-middle row-span-1 col-span-7 md:col-span-1 auto-rows-min">
          {cabinCategoryImage && <img className="rounded-lg mx-auto" src={cabinCategoryImage} alt="room" />}
          {!cabinCategoryImage && <BiBed className="rounded-lg mx-auto border border-black p-2 text-6xl" />}
        </div>
        <div className=" grid grid-cols-8 col-span-7 row-span-1 md:col-span-6">
          <div className=" flex justify-between col-span-8">
            <div className="">
              <div className="font-bold mt-2">
                {cabinCategoryName}
              </div>
              <div className="text-sm">
                Room Type Code:
                {' '}
                {cabinCategoryCode}
              </div>
            </div>
            {!isConfirmation && lowestRate && updateBrochurePriceStatus !== SearchStatus.SEARCHING
              && doShowPrice
              && (!isViewingBrochure || !isViewingCompare || lowestTotalAmount > 0)
              ? (
                <div className="text-right col-span-2 md:col-span-1">
                  <div className="text-gray-600 text-sm font-bold leading-none">from</div>
                  <div className="font-bold leading-none text-base md:text-2xl ">
                    <RateOptionPriceDisclaimerTooltip
                      rate={lowestTotalAmount || lowestRate}
                      isTotalAmount={!!lowestTotalAmount}
                    />
                  </div>
                </div>
              )
              : ''}
          </div>
          <div className="col-span-8 md:col-span-7">
            <p dangerouslySetInnerHTML={{ __html: cabinCategoryDescription }} />
          </div>
        </div>
      </div>
      {rateOptions
        && getSortedRateOptions()
          .map((rateOption, index) => (
            <div key={rateOption.rateOptionCode}>
              <RateOption
                rateOption={rateOption}
                cabinCategoryCode={cabinCategoryCode}
                onModalClose={onModalClose}
                tripId={tripId}
                selectedRoomIndex={selectedRoomIndex}
                doShowPrice={doShowPrice}
                resultno={resultno}
                sessionKey={sessionKey}
                travelOption={travelOption}
                tripRoomSearchInput={tripRoomSearchInput}
              />
              {index < rateOptions.length - 1 && <div className="col-span-2 border border-b-1" />}
            </div>
          ))}
    </div>
  );
};

CabinRate.defaultProps = {
  tripId: undefined,
  onModalClose: () => { },
};

CabinRate.propTypes = {
  tripId: PropTypes.string,
  onModalClose: PropTypes.func,
  cabin: PropTypes.shape({
    cabinCategoryCode: PropTypes.string.isRequired,
    cabinCategoryImage: PropTypes.string,
    cabinCategoryName: PropTypes.string.isRequired,
    cabinCategoryDescription: PropTypes.string.isRequired,
    lowestRate: PropTypes.number,
    lowestTotalAmount: PropTypes.number,
    rateOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    resultno: PropTypes.string.isRequired,
    sessionKey: PropTypes.string.isRequired,
    farecode: PropTypes.string,
  }).isRequired,
  isConfirmation: PropTypes.bool.isRequired,
  doShowPrice: PropTypes.bool,
  selectedRoomIndex: PropTypes.number.isRequired,
  travelOption: PropTypes.shape({
    mode: PropTypes.number,
    key: PropTypes.string,
  }).isRequired,
  tripRoomSearchInput: PropTypes.arrayOf(PropTypes.shape()),
};

CabinRate.defaultProps = {
  doShowPrice: true,
  tripRoomSearchInput: undefined,
};
export default memo(CabinRate);
